import type { IProgressPromise, IProgressPromiseGenerator } from '../../interface/promise';
import type { IFetcher, IFetchRequest } from '../../interface/util';
import type { MediaBinaryStorageTypeMap } from '../interface/media';

const DEFAULT_TIMEOUT = 300 * 1000; /* 5 mins */
const DEFAULT_RETRY_COUNT = 2;

function download<
    K extends keyof MediaBinaryStorageTypeMap,
    V extends MediaBinaryStorageTypeMap[K],
>(
    promiser: IProgressPromiseGenerator,
    fetcher: Promise<IFetcher>,
    requests: Array<IFetchRequest>,
    type: K,
    retryCount = DEFAULT_RETRY_COUNT,
    timeout = DEFAULT_TIMEOUT,
): IProgressPromise<V> {
    return promiser.promise<V>(async function (resolve, reject, progressCb) {
        const fetchLoader = await fetcher;

        for (const request of requests) {
            const promise = fetchLoader<Blob | ArrayBuffer>(request, timeout, retryCount);

            promise.onProgress(function (data) {
                progressCb(data);
            });

            const response = await promise.catch(error => {
                console.error(`Failed to fetch media, error:${JSON.stringify(error)}`);
                return undefined;
            });

            if (!response) {
                console.error(`Request getMedia failed`);
            } else if (!response.payload) {
                console.error(`Missing payload from media response`);
            } else {
                resolve(response.payload as V);
                return;
            }
        }

        reject(new Error(`Failed to get response from requests: ${JSON.stringify(requests)}`));
    });
}

const module = {
    download,
};

export default module;
